import {axios} from '../http'
import config from '../config'
import checkType from '@/utils/checkDataType'
import {
  SET_HOME_MAP,
  SET_HOME_SOLD,
  SET_HOME_STOCK,
  SET_LANG,
  SET_NOTICE_TYPE,
} from './mutation-types'
/**
 * 获取产品型号
 *  [{name: 'A'}] 提取name对应的值组成新数组
 *  */ 
let formatDeviceTypes = (deviceData) => {
  // 判断数据是否存在且类型必须是数组
  // console.log(checkType)
  if (checkType.isArray(deviceData) && deviceData) {
    // [{name: 'A'}] 提取name对应的值组成新数组
    let deviceTypes = []
    deviceData.forEach((d) => {
      deviceTypes.push(d.name)
    })
    return deviceTypes
  }
}
export default {
  // 获取首页数据
  /**
   *
   * 获取首页数据
   * @param {commit} {commit}
   * @param {object} payload
   * @returns Promise
   */
  getHomeData ({commit}, payload) {
    // 这里需要返回一个Promise用于通知echart数据变化了，以便更新echart视图
    // console.log(JSON.stringify(payload))
    return new Promise((resolve, reject) => {
      let payloads = Object.assign({level: 3}, payload)
      axios.post(config.api.home_device_overView_url, payloads).then((res) => {
        let {code, desc, result} = res
        // 如果请求的结果是成功的，那就整理数据并赋值
        if (code === 0 && desc === 'success' && result) {
          // console.log(result)
          // 地图数据统计
          let cityData = []
          result.statistic.map((item) => {
            cityData.push({
              name: item.orgName,
              value: [item.lng, item.lat, item.sold, item.keep]
            })
          })
          // 出货统计
          let selledData = {
            selledDeviceData: result.charts[0].items,
            selledTotal: result.charts[0].totalNum,
            selledDeviceTypes: formatDeviceTypes(result.charts[0].items),
            selledTitle: result.charts[0].title
          }
          // 库存统计
          let stockData = {
            stockDeviceData: result.charts[1].items,
            stockTotal: result.charts[1].totalNum,
            stockDeviceTypes: formatDeviceTypes(result.charts[1].items),
            stockTitle: result.charts[1].title
          }
          // 提交更改
          commit(SET_HOME_SOLD, selledData)
          commit(SET_HOME_STOCK, stockData)
          commit(SET_HOME_MAP,cityData)
          // 暂时返回一个空的Promise
          resolve()
        }
      }).catch((err) => {
        reject(err)
      })
    })
  },
  setAlarmNoticeType ({commit}, type) {
    localStorage.setItem('alarmNoticeType', type + '')
    commit(SET_NOTICE_TYPE, type)
  },
  setLang ({commit}, lang) {
    localStorage.setItem('lang', lang)
    commit(SET_LANG, lang)
  },
  setUser({commit}, payload) {
      commit('SET_USER', payload)
  },
  getUser({commit}, payload) {
      commit('GET_USER', payload)
  },
    setOrg({commit}, payload) {
        commit('SET_ORG', payload)
    },
    getOrg({commit}, payload) {
        commit('GET_ORG', payload)
    },
  setSystem({commit}, payload) {
      commit('SET_SYSTEM', payload)
  },
  getSystem({commit}, payload) {
      commit('GET_SYSTEM', payload)
  },
  setToken({commit}, payload) {
      commit('SET_TOKEN', payload)
  },
  getToken({commit}, payload) {
      commit('GET_TOKEN', payload)
  },
  setLevel({commit}, payload) {
      commit('SET_LEVEL', payload)
  },
  getLevel({commit}, payload) {
      commit('GET_LEVEL', payload)
  },
  setTitlename({commit}, payload) {
      commit('SET_TITLE_NAME', payload)
  },
  logout({commit}, payload) {
      commit('LOGOUT', payload)
  },
  setOrgCoord({commit}, payload) {
    commit('SET_ORGCOORD', payload)
  },
}
